@if (isVisible) {
  <div class="acrylic-surface"></div>
}
